import {
    DivisionAction
} from "../actions";
import {DPart} from "../model";

// Division: Array<DPart>, division of papers
const Division = (state: Array<DPart> = [], action: DivisionAction) => {
    switch (action.type) {
        case "INIT_DIVISION":
            return action.initialState;
        case "CHANGE_DIVISION": {
            let newState = state;
            newState[action.index].cx += 200;
            console.log(newState)
            return newState;
        }
        default:
            return state;
    }
};

export default Division;